<div style="padding: 80px 20px; text-align: center; line-height: 8px">
    <div *ngFor="let item of getMasks(); index as i" style="display: inline-block; overflow: hidden; cursor: pointer"
        [class]="imagesize" (click)="selected = item; selectedIndex = i">
        <img *ngIf="imagesize === 'large'" [class]="imagesize" [src]="'/assets/large/' + (i+1) + '.gif'">
        <img *ngIf="imagesize === 'medium'" [class]="imagesize" [src]="'/assets/medium/' + (i+1) + '.gif'">
        <img *ngIf="imagesize === 'small'" [class]="imagesize" [src]="'/assets/small/' + (i+1) + '.gif'">
    </div>
</div>

<div style="position: fixed; top: 0px; left: 0px; margin: 20px 30px; display: flex">
    <div style="display: inline-block; margin-right: 20px">
        <img src="/assets/banner.png" style="height: 34px; width: 210px">
    </div>
    <div class="bubble" (click)="rotateSize()">{{imagesize}}</div>
</div>

<div *ngIf="selected"
    style="position: fixed; top: 0px; left: 0px; width: 100vw; height: 100vh; z-index: 1; background: #000c">
    <div style="margin-top: 30px; text-align: center" (click)="selected = undefined">
        <img [src]="selected.image" (load)="imageLoaded()"
            style="height: calc(100vh - 70px); width: calc(100% - 80px); margin: 0px 40px; object-fit: contain">
    </div>
    <div style="text-align: center; color: white; text-transform: uppercase">
        <a [href]="'https://opensea.io/item/ethereum/0xdddfec8ba91c0a17b27af2b13b1110aa1f744a86/' + selected.id"
            target="_blank" style="color: white; font-family: 'VCR OSD Mono'; font-size: 20px">
            trappedJPEG #{{selected.id}} {{selected.name}}
        </a>
    </div>
    <div *ngIf="selectedIndex > 0" style="position: fixed; left: 0px; top: calc(50vh - 20px)">
        <button mat-icon-button style="color: white" (click)="selectedMaskBack()">
            <mat-icon>arrow_back_ios</mat-icon>
        </button>
    </div>
    <div *ngIf="selectedIndex < getMasks().length - 1" style="position: fixed; right: 0px; top: calc(50vh - 20px)">
        <button mat-icon-button style="color: white" (click)="selectedMaskForward()">
            <mat-icon>arrow_forward_ios</mat-icon>
        </button>
    </div>
    <div *ngIf="imageLoading"
        style="position: fixed; width: 100vw; height: 100vh; top: 0px; left: 0px; background: #000000bb; z-index: 10">
        <div style="top: calc(45vh - 25px); left: calc(50vw - 25px); position: fixed; z-index: 100000">
            <mat-spinner [diameter]="50" [strokeWidth]="6"></mat-spinner>
        </div>
    </div>
</div>